import { Card, CardContent, style, InlineButton, Box } from '@do/walrus';
import React from 'react';
import styled from 'styled-components';
import { GetSaasAppBySlug_GetSaasAppBySlug_app_plans as SaasPlan } from '../../graphql/generated-types/GetSaasAppBySlug';

interface SelectedPlanCardProps {
  selectedPlanSlug: string;
  plans: SaasPlan[];
  setTabIndex?: React.Dispatch<React.SetStateAction<number>>;
  isPlanTab?: boolean;
}

const PlanName = styled.span`
  font-weight: bold;
  color: ${style.colors.grey.darkest};
  max-width: 330px;
  word-wrap: break-word;
`;

const EditButton = styled(InlineButton)<{ isEnabled?: boolean }>`
  opacity: ${(props) => (props.isEnabled ? 1 : 0.5)};
  cursor: default;
  pointer-events: ${(props) => (props.isEnabled ? `unset` : 'none')};

  &&:hover {
    text-decoration: none;
  }
`;

export const SelectedPlanCard: React.FC<SelectedPlanCardProps> = ({
  selectedPlanSlug,
  plans,
  setTabIndex,
  isPlanTab
}) => {
  const defaultPlan = plans.find((plan) => plan.by_default) || plans[0];
  const selectedPlan =
    plans.find((plan) => plan.slug === selectedPlanSlug) || defaultPlan;

  return (
    <Card>
      <CardContent>
        <div className="do-u-flex do-u-flexSpaceBetween">
          <strong>PLAN</strong>
          <Box mb={2}>
            <EditButton isEnabled={!isPlanTab} onClick={() => setTabIndex(1)}>
              <strong>Edit</strong>
            </EditButton>
          </Box>
        </div>
        <div className="do-u-flex do-u-flexSpaceBetween">
          <PlanName>{selectedPlan.display_name}</PlanName>
        </div>
        <div>
          ${selectedPlan.price_per_month}/month{' '}
          {selectedPlan.dimensions?.length ? 'plus usage' : ''}
        </div>
      </CardContent>
    </Card>
  );
};
